import { ResetPasswordForm } from "@/components/common/ResetPasswordForm";

export default function Reset() {
  return (
    <div className="w-full h-screen flex">
      <div className="w-full flex justify-center h-full">
        <div className="w-1/2 max-w-[400px] content-center">
          <ResetPasswordForm />
        </div>
      </div>
    </div>
  );
}
